type ProjectSeoImageInput = {
  template_url?: string | null
  logo_url?: string | null
  logo_symbol_url?: string | null
}

export const resolveProjectSeoImage = ({
  template_url,
  logo_url,
  logo_symbol_url
}: ProjectSeoImageInput): string | undefined => {
  const logo = String(logo_url || '').trim()
  const template = String(template_url || '').trim()
  const symbol = String(logo_symbol_url || '').trim()

  return logo || template || symbol || undefined
}
